var React = require('react');

function MusicAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M352 32v64a32 32 0 0 1-23 30.71l-73 21.39V17.56l54.94-16.23A32 32 0 0 1 352 32z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M256 432c0 44.18-50.14 80-112 80S32 476.18 32 432s50.14-80 112-80a148.76 148.76 0 0 1 48 8V60.34a32 32 0 0 1 22.41-30.5L256 17.56z","className":"fa-primary","key":2})]);
}

MusicAlt.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = MusicAlt;

MusicAlt.default = MusicAlt;
